// utils/aes.js
import CryptoJS from 'crypto-js'

// 示例密钥和IV（32位字符和16位字符），务必与后端协商一致，并妥善管理
const DEFAULT_KEY = 'qF6wL9pX2sV8zR1tY5uM3nB7vC0xK4jH'
const DEFAULT_IV = 'xM9rB2vN5tY8uJ1i'

/**
 * AES-256-CBC 加密
 * @param {string} plainText 需要加密的明文
 * @param {string} [keyStr] 密钥，可选，不传则使用默认值
 * @param {string} [ivStr] 初始化向量，可选，不传则使用默认值
 * @returns {string} 加密后的Base64格式密文
 */
export function encrypt (plainText, keyStr = DEFAULT_KEY, ivStr = DEFAULT_IV) {
  const key = CryptoJS.enc.Utf8.parse(keyStr)
  const iv = CryptoJS.enc.Utf8.parse(ivStr)
  const srcs = CryptoJS.enc.Utf8.parse(plainText)

  const encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7 // 与后端常见的PKCS5Padding兼容:cite[3]:cite[6]
  })

  // 返回Base64字符串:cite[3]:cite[4]
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
}

/**
 * AES-256-CBC 解密
 * @param {string} cipherText 需要解密的Base64格式密文
 * @param {string} [keyStr] 密钥，可选，不传则使用默认值
 * @param {string} [ivStr] 初始化向量，可选，不传则使用默认值
 * @returns {string} 解密后的明文
 */
export function decrypt (cipherText, keyStr = DEFAULT_KEY, ivStr = DEFAULT_IV) {
  const key = CryptoJS.enc.Utf8.parse(keyStr)
  const iv = CryptoJS.enc.Utf8.parse(ivStr)

  // 将Base64密文转换为CryptoJS可识别的格式
  const decrypted = CryptoJS.AES.decrypt(cipherText, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })

  return decrypted.toString(CryptoJS.enc.Utf8)
}


// WEBPACK FOOTER //
// ./src/utils/aes.js